import { defineStore } from 'pinia'
import { fetchWrapper } from '@/helpers/fetch-wrapper';
import { ref } from 'vue'

const baseUrl = `${import.meta.env.VITE_BASE_URL}`;

export const useNotificationsStore = defineStore('notifications', () => {
  const notifications = ref([])

  async function fetchNotifications(query = null) {
    let url = new URL(`${baseUrl}/notifications/`)
    url.searchParams.set('limit', '100000')
    if (query != null) {
      try {
        query.forEach((value, key) => url.searchParams.set(key, value))
      } catch (err) {
        console.log(err)
      }
    }
    return new Promise((resolve, reject) => {
      fetchWrapper.get(new String(url)).then((results) => {
        if (results.length > 0) {
          results.map((item) => {
            const results = notifications.value
            const notificationIndex = results.findIndex(n => n.id === item.id)
            if (notificationIndex !== -1) {
              results[notificationIndex] = item
              notifications.value = results
            } else {
              notifications.value.unshift(item)
            }
          })
        }
        resolve(results)
      }).catch((error) => {
        reject(error)
      });
    })
  }
  async function readNotifications(data) {
    return new Promise((resolve, reject) => {
      fetchWrapper.post(`${baseUrl}/notifications/read/`, data).then((data) => {
        data.notification_ids.map((itemId)=> {
          const results = notifications.value
          const notificationIndex = results.findIndex(n => n.id === itemId)
          results[notificationIndex].read = true
          notifications.value = results
        }) 
        resolve('ok')
      }).catch((error) => {
        reject(error)
      });
    }
    )
  }
  return {
    notifications,
    fetchNotifications,
    readNotifications,
  }
})
